module.exports = __webpack_public_path__ + "static/media/why-habit.dbf5c45f.jpeg";